export const industryWarnings = {
  computed: {
    industrySwalOptions() {
      return {
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        width: '38em',
        reverseButtons: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: 'primary-color margin-left-btn v-btn v-btn--contained v-size--default primary',
          cancelButton: 'v-btn v-btn--depressed v-btn--flat v-btn--outlined theme--light v-size--default primary--text',
        },
      }
    },
  },
  methods: {
    industryFinishWarning(status) {
      return {
        title: 'Finalizar Campanha',
        message: `Ao finalizar uma campanha de trade, não será possível ativá-la novamente. A campanha será movida para o status ${status}.`,
        confirmText: 'Finalizar',
        cancelText: 'Cancelar',
      }
    },
    industryAlterationWarning() {
      return {
        title: 'Alterar campanha',
        message: `Ao alterar essa campanha de trade, ela será movida para o status expirada, pois o prazo de adesão escolhido é anterior a hoje.`,
        confirmText: 'Alterar',
        cancelText: 'Cancelar',
      }
    },
  },
}
